export default {
    company: {
        company_information: 'Карточка компании',
        companyName: 'Название',
        companyAltName: 'Альтернативное название',
        address: 'Адрес',
        contacts: 'Контакты',
        webpage: 'Сайт компании',
        links: 'Связанные компании',
        legal: 'Юридические лица',
        department: 'Структура компании',
        labels: 'Метки',
        employees: {
            title: 'Сотрудники',
            fullName: 'ФИО',
            position: 'Должность',
            department: 'Отдел',
            workDate: 'Работает с'
        }
    }
};
